import SummitAttendeeManagers from './SummitAttendeeManagers'

export default SummitAttendeeManagers
